
import { useContext } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { toast, ToastContainer } from 'react-toastify';
import { AppContext } from "../../utils/context/app.context.js";
import FormComponent from "../../utils/components/form.component.js";
import systemService from "../../services/system.service.js";

export default function Reset() {
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [user] = useState(searchParams.get("user"));
    const [token] = useState(searchParams.get("token"));
    const [reseted, setReseted] = useState(false);

    console.log(user, token)

    function onSubmit(form) {
        if (form.pass === form.pass2) {
            toast.info(t('actions.procesing'), { autoClose: 1500, theme: "light", });
            systemService.app_reset({ ...form, user, token })
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('reset.success'));
                        setReseted(true);
                    }
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t)
                })
        }
        else
            toast.warning(t('reset.passError'));
    }

    const passRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/;

    const FORM = () => [
        {
            title: t('reset.form.section'),
            inputs: [
                [
                    { id: "pass", title: t('reset.form.pass'), placeholder: t('reset.form.pass'), icon: "key", required: true, type: "password", max: 16, min: 8, pattern: passRegex, },
                    { id: "pass2", title: t('reset.form.pass2'), placeholder: t('reset.form.pass'), icon: "key", required: true, type: "password", max: 16, min: 8, pattern: passRegex, },
                ],
            ]
        },
    ]

    return (
        <div className="app-container">
            <div className="app-overlay">
                <div className="row m-0 p-o">
                    <div className="container">
                        <div className="row justify-content-center m-5">
                            <div className="col-md-6 col-sm-12">

                                <ToastContainer theme="colored" />
                                <h2>{t("reset.title")}</h2>
                                <hr />
                                {reseted ? <>
                                    <h5>{t("reset.reseted")}</h5>
                                    <p className="text-center"><a href="#" onClick={() => navigate("/login")} > {t("reset.back")}</a></p>
                                </> : <>
                                    {user && token ? <>
                                        <FormComponent
                                            actions={{
                                                primary: { icon: "send-message", text: t('actions.send') },
                                                secondary: { icon: "arrow-left", text: t('actions.back') }
                                            }}
                                            onSecondary={() => navigate("/login")}
                                            onSubmit={(data) => onSubmit(data)}
                                            groups={FORM()}
                                            footer={<>
                                                <div className='row'>
                                                    {t("signin.passreq")}
                                                </div>
                                            </>}
                                        />
                                    </> : <h5>{t("reset.nodata")}</h5>}
                                </>}



                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div >

    );
}
